<template>
  <Modal v-model="visible" width="1300px" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal">
    <!-- <div class="search-box btn3">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
      </div>
      <div v-if="showUser" class="input-item">
        <span class="label">出单业务员</span>
        <Select clearable v-model="searchParams.userId" style="width: 256px" filterable :transfer="true">
          <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index" :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div> -->
    <br/>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="receiptRevisitStatus">
          <div>{{ RECEIPT_STATUS[row.receiptStatus] }}/{{ VERIFY_STATUS[row.verifyStatus] }}</div>
        </template>
        <template slot-scope="{ row }" slot="userName"> <span :class="row.workingState == 1 ? 'opening' : 'close'"></span>{{ row.userName }} </template>
        <template slot-scope="{ row }" slot="rateMode">
          <span>{{ row.rateMode == 1 ? '年度' : '月度' }}</span>
          <template v-if="row.calculateIndex == 1">R13</template>
          <template v-else-if="row.calculateIndex == 2">R25 </template>
          <template v-else-if="row.calculateIndex == 3">R37</template>
          <template v-else>R49</template>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="openDetail(row)">明细</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      columns: [],
      searchParams: {},
      title:'保单明细',
      visible: false,
      loading: false,
      showUser:true,
      detailCode: '',
      salesmanList: []
    };
  },
  created() {},
  methods: {
    openDetail(row) {
      this.$emit('openDetail', { ...row, detailId: this.searchParams.detailId, salaryDetailId: this.searchParams.salaryDetailId, detailCode: this.detailCode });
    },
    // 通过机构获取业务员
    getOrganizationUser() {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: 'POST',
        data: {
          orgaList: []
        }
      }).then(res => {
        this.salesmanList = res.data;
      });
    },
    open({ columns, params, detailCode }) {
      if(params.userId){
        this.showUser = false;
      }
      this.getOrganizationUser(null);
      this.searchParams = {};
      this.visible = true;
      this.columns = columns;
      this.detailCode = detailCode;
      if(params.title){
        this.title = params.title
      }

      this.searchParams = {
        ...this.searchParams,
        ...params
      };
      this.initListAjax('/buz/userSettlementDetail/baseMethod/queryDetail');
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  .btn-add {
    cursor: pointer;
    color: #236dff;
    margin-left: 10px;
  }

  /deep/ {
    .ivu-checkbox-inner {
      top: -1px;
    }

    .ivu-checkbox-group-item {
      width: 25%;
      margin-right: 0;
    }
  }
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
